
<script>
    function scrollTo (id) {
        let el = document.querySelector('[data-step="' + id + '"]');
        el.scrollIntoView();
    }
</script>

<main>
    <div class="legend">
        <h1>Wat <br/> de <br/> Stufi?!</h1>
        <br/>
        <ul>
            <button on:click={() => {scrollTo(1)}} data-chapter="1"><li>Wat is Stufi</li></button>
            <button on:click={() => {scrollTo(2)}} data-chapter="2"><li>De Spelregels</li></button>
            <button on:click={() => {scrollTo(3)}} data-chapter="3"><li>Rente</li></button>
            <button on:click={() => {scrollTo(4)}} data-chapter="4"><li>Jouw Schuld</li></button>
            <button on:click={() => {scrollTo(5)}} data-chapter="5"><li>De Opbouwfase</li></button>
            <button on:click={() => {scrollTo(6)}} data-chapter="6"><li>De Aanloopfase</li></button>
            <button on:click={() => {scrollTo(7)}} data-chapter="7"><li>De Aflosfase</li></button>
            <button on:click={() => {scrollTo(8)}} data-chapter="8"><li>Aan Het Einde</li></button>
        </ul>
    </div> <!-- einde .legend -->
</main>

